<template>
  <div class="wrapper">
    <side-bar :data-active-color="'success'" v-if="token !== null">
      <template slot="links">
        <!-- <sidebar-link to="/dashboard" name="Dashboard" icon="ti-home" /> -->
        <sidebar-link to="/datapoints" name="Datapoints" icon="ti-zip" />
        <sidebar-link v-if="showStudies" to="/studies" name="Studies" icon="ti-book" />
        <sidebar-link to="/users" name="Users" icon="ti-user" />
        <sidebar-link v-if="showTasks" to="/tasks" name="Tasks" icon="ti-alarm-clock" />
        <!--sidebar-link to="/schemes" name="Schemes" icon="ti-panel" /-->
      </template>
      <!-- <template v-else slot="links">
        <sidebar-link to="/login" name="Login" icon="ti-user" />
      </template> -->
      <mobile-menu></mobile-menu>
    </side-bar>
    <div :class="token !== null ? 'main-panel' : 'fullwidth-panel'">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <notifications></notifications>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
	  showTasks() {
		  return this.$store.getters.getShowTasks;
	  },
	  showStudies() {
		  return this.$store.getters.getShowStudies;
	  }
  }
};
</script>
<style lang="scss">
.fullwidth-panel {
  background-color: #f4f3ef;
  position: relative;
  z-index: 2;
  float: right;
  width: 100%;
  min-height: 100%;
  overflow: auto;
}
</style>
